import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

const initialState = {
  description: '',
  maxLength: 30,
}

export const updateRestrictionIpDescription = createAxiosThunk(
  'restrictionIpUpdate/updateRestrictionIpDescription',
  ({ id, description }) =>
    api.restrictionIp.updateRestrictionIpDescription({ id, description })
)

const restrictionIpUpdateSlice = createSlice({
  name: 'restrictionIpUpdate',
  initialState,
  reducers: {
    reset: () => initialState,
    setDescription: (state, { payload: description }) => {
      state.description = description
    },
  },
})

export const { reset, setDescription } = restrictionIpUpdateSlice.actions
export default restrictionIpUpdateSlice.reducer
